import { Colors } from '@be-brite/briteui';
import { StarFour, X } from 'phosphor-react';
import { Box, Button, Modal, Text } from '../shared-components';
import { AssistantChatProvider } from './context/AssistantChatProvider';
import { useDeviceType } from './hooks/useDeviceType';
import { AssistantChatInput } from './AssistantChatInput';
import { AssistantChatThread } from './AssistantChatThread';

export const AssistantChatWindow = ({ close }) => {
  const { isMobile } = useDeviceType();
  return (
    <AssistantChatProvider>
      <AssistantChatWindow.Container {...{ isMobile }}>
        <AssistantChatWindow.Header {...{ close }} />
        <AssistantChatWindow.Content />
      </AssistantChatWindow.Container>
    </AssistantChatProvider>
  );
};

AssistantChatWindow.Container = ({ isMobile, children }) => {
  const containerStyles = `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0px 24px 12px 24px;
  `;

  if (isMobile) {
    return (
      <Modal
        full
        display
        css={`
          ${containerStyles}
          box-sizing: border-box;
        `}
      >
        {children}
      </Modal>
    );
  }

  return (
    <Box
      css={`
        ${containerStyles}
        width: 600px;
        height: 600px;
        background: #fbfbfb;
        border-radius: 8px;
        border: 1px solid ${Colors.Gray300};
        box-shadow: 0px 0.5px 7.5px 2px rgba(182, 182, 182, 0.25);
      `}
    >
      {children}
    </Box>
  );
};

AssistantChatWindow.Header = ({ close }) => {
  return (
    <Box
      css={`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 24px;
        width: 100%;
        height: 50px;
        border-bottom: 1px solid ${Colors.Gray300};
      `}
    >
      <Box
        css={`
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;
        `}
      >
        <StarFour color={Colors.Purple} weight="fill" size={24} />
        <Text
          h4
          color={Colors.Black}
          css={`
            font-weight: 500;
          `}
        >
          Benefits Assistant
        </Text>
      </Box>
      <Button
        styles="icon"
        css={`
          margin-right: -12px;
          padding: 0px;
        `}
        onClick={() => close()}
      >
        <X size={24} />
      </Button>
    </Box>
  );
};

AssistantChatWindow.Content = () => {
  return (
    <Box
      css={`
        display: flex;
        flex-direction: column;
        height: calc(100% - 74px);
        width: 100%;
      `}
    >
      <Box
        css={`
          flex: 1;
          padding-top: 12px;
          overflow-y: auto;

          /* Hide scrollbar for Chrome, Safari and Opera */
          &::-webkit-scrollbar {
            width: 0px;
            background: transparent;
          }
          /* Hide scrollbar for IE, Edge and Firefox */
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE and Edge */
        `}
      >
        <AssistantChatThread />
      </Box>
      <Box
        css={`
          padding: 12px 0px;
        `}
      >
        <AssistantChatInput />
      </Box>
      <Text helper color={Colors.Gray400}>
        Benefits Assistant can make mistakes. Please review sources when provided.
      </Text>
    </Box>
  );
};
